// removed by extract-text-webpack-plugin
module.exports = {"m-checkoutInformation":"TpfhHQCii_WPkwVv4tVKX","a-continueShopping":"_10FIgYRT_MdqYh8TaCotuu","promotion":"_25e6JiG74vizz1Oena-uY0","a-helpline":"D5dl2yV3feFh4l8RWkzvO","a-ccmail":"GqWXzkQqgiwx2XMCPgRsp"};


//////////////////
// WEBPACK FOOTER
// ./shared/components/FooterPromotions/FooterCheckoutStyle.scss
// module id = 883
// module chunks = 0